<template>
  <div id="app" class="app cadfm-container-vertical --dark">

    <Header :lang="lang.Header"></Header>
    <div class="cadfm-flexitem-stretched">
      <router-view :lang="lang" />
    </div>
    <Footer :lang="lang.Footer"></Footer>
    <!--<textarea id="logarea"></textarea>-->
    <AlertComponent :lang="lang.AlertComponent"></AlertComponent>
    <ModalSearchPartsComponent :lang="lang.ModalComponent"></ModalSearchPartsComponent>
    <ModalComponent :lang="lang.ModalComponent"></ModalComponent>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import Footer from '@/components/Footer/Footer'
  import AlertComponent from "@/components/shared/AlertComponent"
  import ModalComponent from "@/components/shared/ModalComponent"
  import ModalSearchPartsComponent from "@/components/shared/ModalSearchPartsComponent"

  import * as lang from "@/Tools/lang"

  export default {
    name: 'App',
    components: {
      Header,
      Footer,
      AlertComponent,
      ModalComponent,
      ModalSearchPartsComponent
    },
    data() {
    return {
      lang: lang.data[this.$store.getters.langVariant],
      

    }
    },
    computed:{
      langVariant() {
        return this.$store.getters.langVariant
      }
  }, beforeMount() {
      let vue = this;
      // window.addEventListener("beforeunload", (e) => {
        
        
      //   localStorage.setItem('prefix', vue.$store.getters.sectionPrefix);
        
      // })
    },
    created () {
      
      this.$store.dispatch("getGlobalSettings");
      this.$store.dispatch("getSettings");

      const pageAccessedByReload = (
        (window.performance.navigation && window.performance.navigation.type === 1) ||
        window.performance
          .getEntriesByType('navigation')
          .map((nav) => nav.type)
          .includes('reload')
      );

      if (pageAccessedByReload) {
        let to = "/Dashboard/DashboardWidgets";

        this.$router.push({ path: to });
      }

      // if (localStorage.getItem('prefix') != "") {
      //   let prefix = localStorage.getItem('prefix');
      //   localStorage.setItem('prefix', "");
        

      //   let to = "";
      //   if (prefix == "d") {
      //     to = "/Dashboard/DashboardWidgets";
      //   }
      //   if (prefix == "pm") {
      //     to = "/PartManager/PartTable";
      //   }
      //   if (prefix == "lm") {
      //     to = "/LibraryManager/LibraryTable";
      //   }
      //   if (prefix == "projm") {
      //     to = "/ProjectManager/ProjectTable";
      //   }
      //   if (prefix == "u") {
      //     to = "/Users/Main";
      //   }
      //   if (prefix == "s") {
      //     to = "/Settings/Main";
      //   }
      //   if (prefix == "a") {
      //     to = "/About/Main";
      //   }

        
      //   const query = {
      //     from: this.$route.path,
      //     to: to,
          
      //   }
        
      //   this.$router.push({ path: to, query: query })
      // } 
      
    },
    mounted() {
      
    },

  }
</script>

<style lang="scss">
//@import './scss/_custom.scss';
  //@import "node_modules/bootstrap/scss/bootstrap";

  //@import './scss/_custom.scss';
  //@import "node_modules/bootstrap/scss/bootstrap";
  //@import 'bootstrap-vue/dist/bootstrap-vue.css';
  //@import "node_modules/bootstrap/scss/_functions.scss";
  //@import "./scss/_custom.scss";
  @import "./scss/_theme.scss";
  @import "./scss/_mixins.scss";
  @import "./scss/_modal.scss";
  


  //@import '~bootstrap/scss/bootstrap.scss';
  //@import '~bootstrap-vue/src/index.scss';

  /* BASIC LAYOUT ...*/



  html, body {
    height: 100vh;
    margin: 0;
    padding: 0;
    
    /*@if ($theme == "light"){
        color: var(--text--color--light);
        background-color: var(--bg--color-light);
    }
    @else{
        color: var(--text--color--dark);
        background-color: var(--bg--color--dark);
    }*/
  }

  .Header{
    z-index: 1000;
  }

  /*a container for flex elements distributed vertically*/
  .cadfm-container-vertical {
    display:flex;
    flex-flow:column nowrap;
    width:100%;
    height:100%;
    overflow:hidden;
    position:relative;
  }

  /*a container for flex elements distributed horizontally*/
  .cadfm-container-horizontal {
    display:flex;
    flex-flow:row nowrap;
    width:100%;
    height:100%;
    overflow:hidden;
  }

  /*a flex item that will always try to fit all its content if explicit size is not defined*/
  /*  it will adjust to explicitly defined size thus allowing panel-resize-like features*/
  .cadfm-flexitem-fixed {
    flex: 0 0 auto;
    overflow:auto;
    position:relative;
    scrollbar-color: #666 #222;
    scrollbar-width: thin;
  }
  

  /*a flex item that will grow to fill all the space left in its container */
  /*  or will shrink showing a scroll-bars to scroll their content */
  /*  override with flex-grow > 1 to controll the distribution of space between multiple flexitems*/
  /*  otherwise the space will be distributed equally between all stretched flexitems */
  .cadfm-flexitem-stretched{
    flex: 1 1 auto;
    overflow:auto;
    position:relative;
    scrollbar-color: #666 #222;
    scrollbar-width: thin;
  }
  

  .cadfm-container-vertical >.cadfm-flexitem-stretched {
    /*height:0px;*/

    /*flex-basis: 0px;*/
  }

  .cadfm-container-horizontal >.cadfm-flexitem-stretched {
    width:0px;
    /*flex-basis: 0px;*/
  }


  /* ... END BASIC LAYOUT*/



  .app {
    //font-family: Arial, Helvetica, Verdana, sans-serif;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-size: 0.75rem;


  }
  //@import "./scss/custom";
  @import "./scss/_dark.scss";
  @import "./scss/_light.scss";
  @import "./scss/_modal.scss";
  
  .invalid-feedback{
    color: #FF2200 !important;
  }

  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #FF2200;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 34, 0, 0.5);
    box-shadow: 0 0 0 0.2rem rgba(255, 34, 0, 0.5);
  }
  
  .btn {
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 3px;
    padding-right: 3px;
  }

  .btn-sm,
  .btn-group-sm > .btn {
    padding: 0.15rem 0.4rem 0.15rem 0.4rem;
    font-size: 0.75rem !important;
    line-height: 1.5;
    border-radius: 0.2rem;
  }

  .badge{
    font-size: 100% !important;
  }

  .badge{
      padding-right: 0.6em;
      padding-left: 0.6em;
      border-radius: 10rem;
      padding-top: 0.15em;
      padding-bottom: 0.3em;
  }

  .alert{
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    padding: 0.1rem 1rem !important;
  }

  .dataTables_info{
        max-width: 49%;
        float: left;
  }
  .dataTables_paginate {
      max-width: 49%;
      float: right;
  }
    .--darkModal {
      //Datatables
      table.dataTable tbody>tr.selected[role="row"],
      table.dataTable tbody>tr[role="row"]>.selected {
        background-color: #ccc;
  
        td {
          color: #333 !important;
        }
      }

      //Tree
      .ItemTree .active {
        background-color: #ccc;
        color: #333 !important;
      }
      .ItemSearchPartsTree .active {
        background-color: #ccc;
        color: #333 !important;
      }
  
    }
  .--lightModal{
    //Datatables
    table.dataTable tbody>tr.selected[role="row"],
      table.dataTable tbody>tr[role="row"]>.selected {
        background-color: #333333;
        td {
            color: #ccc !important;
        }
     }
    //Tree
    .ItemTree .active {
      background-color: #ccc;
      color: #333 !important;
    }
    .ItemSearchPartsTree .active {
      background-color: #ccc;
      color: #333 !important;
    }
      
  }
    

  .--custom {
    .ActionButton {
      .btntext {
        
        font-size: $light-iconFontSize;
      }
    }
    .TooltipIcon {
      .btntext {
        
        font-size: $light-iconFontSize;
      }
    }


    
  }

  .--dark2{
    color: red;
  }

  .card-deck .card {
 
    margin-right: 0px !important;
  }

  small, .small {
    font-size: 90% !important;
    font-weight: 400 !important;
  } 

  
  .modal-xxl{
    max-width: 2000px !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
    .modalPartTable {
      overflow: hidden;
      overflow-x: auto;
    }

  // .hdl-arc {

  //   stroke: green;

  //   stroke-width: 2;

  //   fill: none;

  // }

  // .hdl-line {

  //   stroke: green;

  //   stroke-width: 2;

  // }

  // .hdl-line.hdl-thick {

  //   stroke-width: 4;

  // }

  // .hdl-pin-name {

  //   fill: black;
  //   stroke: none;
  // }

  // .hdl-pin-prop {

  //   fill: green;

  // }
  // .hdl-text-span{
  //   fill: green;
  //   stroke: none;
  // }

  // .hdl-part-prop[data-property-name]:not([data-property-name=""]) {

  //   fill: orange;

  // }
    .hdl-arc {
  
      stroke: green;
  
      stroke-width: 2;
  
      fill: none;
  
    }
  
    .hdl-line {
  
      stroke: green;
  
      stroke-width: 2;
  
    }
  
    .hdl-line.hdl-thick {
  
      stroke-width: 4;
  
      fill: none;
  
    }
  
    .hdl-pin-name {
  
      fill: black;
  
      stroke: none;
  
    }
  
    .hdl-pin-prop {
  
      fill: green;
  
      stroke: none;
  
    }
  
    .hdl-part-prop[data-property-name]:not([data-property-name=""]) {
  
      fill: orange;
  
      stroke: none;
  
    }
  
    .hdl-pin-name.hdl-thick {
  
      fill: black;
  
      stroke: black;
  
    }
  
    .hdl-pin-prop.hdl-thick {
  
      fill: green;
  
      stroke: green;
  
    }
  
    .hdl-part-prop.hdl-thick[data-property-name]:not([data-property-name=""]) {
  
      fill: orange;
  
      stroke: orange;
  
    }
    
</style>



// WEBPACK FOOTER //
// src/App.vue